import FeatureCard from "./Featurecard";
import {
  FaChartLine,
  FaUsers,
  FaIndustry,
  FaBrain,
  FaRocket,
  FaMicrochip,
} from "react-icons/fa";

// import IOT from "../../../public/curriculum/Become a Certified IOT";

export default function WhyChoose() {
  const whyChooseData = [
    {
      icon: FaChartLine,
      title: "Future Careers",
      description:
        "By 2030, billions of smart devices will drive demand for IoT and robotics professionals.",
    },
    {
      icon: FaUsers,
      title: "High Demand",
      description:
        "Engineers with IoT and automation skills are among today's most sought-after professionals.",
    },
    {
      icon: FaIndustry,
      title: "Smart Manufacturing",
      description:
        "Transform industries using automation, robotics, and intelligent production systems.",
    },
    {
      icon: FaBrain,
      title: "AI Integration",
      description:
        "Combine artificial intelligence with robotics to build autonomous smart solutions.",
    },
    {
      icon: FaRocket,
      title: "Startup Opportunities",
      description:
        "Launch innovative products and businesses in the rapidly growing IoT ecosystem.",
    },
    {
      icon: FaMicrochip,
      title: "Industry 4.0 Skills",
      description:
        "Develop practical skills required for smart factories and digital transformation.",
    },
  ];
  return (
    <section className="py-24 ">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between gap-8 mb-16">
          <div>
            <p className="uppercase tracking-[3px] text-blue-600 font-semibold text-xs">
              WHY CHOOSE US
            </p>

            <h2 className="md:text-5xl text-3xl mt-4 leading-tight">
              Why Master IoT &
              <br />
              Robotics Now?
            </h2>

            <p className="mt-6 text-gray-500 max-w-xl leading-8">
              Industry 4.0 is transforming manufacturing, healthcare,
              agriculture, transportation, and smart cities. Become one of the
              engineers shaping the future.
            </p>
          </div>

          <a
            href="/curriculum/IOT-ROBOTIC-HARDWARE-ENGINEERING.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="self-start bg-[#000D83] text-white px-8 py-4 rounded-full hover:bg-[#01063b] transition"
          >
            View Career Guide
          </a>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseData.map((item) => (
            <FeatureCard
              key={item.title}
              Icon={item.icon}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
